export interface IPersonalInformation {
    organizationName: string;
    firstName: string;
    lastName: string;
    locale: string;
}
